/*
* TrackingTable页面title枚举值
* */
export enum TrackingTableTitle {
    RETURN_TO_WHS = 'Return-to-WHS',
    NEW_ASSIGNMENTS_DETAILS = 'New Assignments Details',
    TRANSFER_IN_DETAILS = 'Transfer-in Details',
    TRANSFER_OUT = 'Transfer-out',
    ARRIVAL_SCAN_DETAILS = 'Arrival Scan Details',
}